<template>
  <div v-if="orderDetail">
    <!--商家名字-->
    <div style="font-size: 15px;" v-if="orderType === 'myOrder'">
      {{merchantsName(orderDetail.merchants)}}
    </div>
    <tk-flex middle class="m-l-10 font-bold" v-else>
      <tk-avatar size="20">
        <tk-image
          :src="orderDetail.buyUser.avatar ? orderDetail.buyUser.avatar : defaultImage"
          :width="30" :height="20"></tk-image>
      </tk-avatar>
      <div class="font-14 m-l-15">{{orderDetail.buyUser.name}}</div>
    </tk-flex>
    <!--商品列表-->
    <div
      v-for="(m, index) in orderDetail.commodityData"
      :key="`commodity${index}`"
    >
      <tk-flex
        middle
        class="m-t-8 full-width"
      >
        <div class="commodity-style-image">
          <tk-image :src="m.showPictures[0]" :width="90" :height="90"></tk-image>
        </div>
        <tk-flex class="m-l-10 tk-grid-7 fill" column>
          <div class="class-card-wrap van-multi-ellipsis--l2 font-14">{{m.productTitle}}</div>
          <div style="height: 20px;"></div>
          <tk-flex middle class="full-width">
            <div class="commodity-style-price"><span class="font-10">￥</span>{{m.price}}</div>
            <div class="primary-gray font-14 m-l-15" style="padding-top: 1px;">{{'×' + m.numberOrders}}</div>
          </tk-flex>
        </tk-flex>
      </tk-flex>
    </div>
    <tk-flex right class="font-12">
      <div>{{'共' + commoditySum + orderUnit}}</div>
      <div class="m-l-15">{{'合计：' + '￥'}} <span class="font-bold">{{orderDetail.orderAmount}}</span></div>
    </tk-flex>
    <!--买家留言-->
    <tk-flex  v-if="isShowMessage" class="m-t-8">
      <div class="font-14">买家留言</div>
      <div class="leave-input">{{orderDetail.leaveMessage ? orderDetail.leaveMessage : '没有留言...'}}</div>
      <!-- <label>
        <input :disabled="true" type="text" class="leave-input" :placeholder="orderDetail.leaveMessage ? orderDetail.leaveMessage : '没有留言...'"/>
      </label> -->
    </tk-flex>
  </div>
</template>

<script>
export default {
  props: {
    orderDetail: {
      type: Object
    },
    isShowMessage: {
      type: Boolean,
      default: true
    },
    orderType: {
      type: String,
      default: 'myOrder'
    }
  },
  computed: {
    // 计算商品件数
    commoditySum () {
      if (!this.orderDetail) { return 0 }
      if (!this.orderDetail.commodityData) { return 0 }
      let sum = 0
      this.orderDetail.commodityData.forEach(s => {
        if (!s.numberOrders) { s.numberOrders = 0 }
        sum += s.numberOrders
      })
      return sum
    },
    // 根据身份判断单位
    orderUnit () {
      if (this.orderType === 'clientOrder' &&
        !this.isTerminalAccount) {
        if (this.isFactoryAccount) { return '件' } else { return '个' }
      } else if (this.orderType === 'myOrder') {
        if (this.isTerminalAccount) { return '个' } else { return '件' }
      }
      return '个'
    }
  },
  methods: {
    /**
     * 商家名字
     * @date: 2020/4/1
     */
    merchantsName (merchants) {
      if (merchants.accountCategory === 'countyAccount') {
        return `${merchants.name}`
      }
      if (merchants.accountCategory === 'factoryAccount') {
        if (!merchants.brandName) { merchants.brandName = '厂家' }
        return `${merchants.brandName}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /*买家留言样式*/
  .leave-input {
    margin-left: 18px;
    font-size: 12px !important;
    color: rgba(153, 153, 153, 1);
    flex: 1;
    // overflow : hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 3;
    // -webkit-box-orient: vertical;
  }
  .leave-input::-webkit-input-placeholder {
    font-size: 12px !important;
    color: rgba(153, 153, 153, 1);
  }
  .leave-input::placeholder {
    font-size: 12px !important;
    color: rgba(153, 153, 153, 1);
  }
</style>
